import React from 'react';
import { ListNutritionistsResponseElement } from '../../../types/apiGeneratedTypes';
import TableRowActionMenu from '../../BaseComponents/TableRowActionMenu';
import { useDispatch } from 'react-redux';
import {
  changeModalVisibility,
  setNutritionistDataToEdit,
  setNutritionistsList
} from '../../../store/nutritionistsSlice';
import {
  deleteNutritionist,
  activateNutritionist,
  deactivateNutritionist,
  getNutritionistsList
} from '../../../api/nutritionist';
import { toast } from 'react-toastify';
import './NutritionistTable.scss';

type Props = {
  nutritionistData: ListNutritionistsResponseElement;
};

const NutritionistTableRow = ({ nutritionistData }: Props) => {
  const dispatch = useDispatch();

  const onOptionClick = async (id: string, action: string) => {
    if (action === 'edit') {
      dispatch(setNutritionistDataToEdit(nutritionistData));
      dispatch(changeModalVisibility(true));
    } else if (action === 'delete') {
      if (
        nutritionistData.members_count &&
        nutritionistData.members_count > 0
      ) {
        toast.error(
          'Deletion failed — this nutritionist is assigned to a member'
        );
        return;
      }
      try {
        await deleteNutritionist(nutritionistData.id);
        toast.success('Nutritionist deleted successfully');
      } catch (error) {
        console.error('Error deleting nutritionist:', error);
        toast.error('Error deleting nutritionist');
      } finally {
        window.location.reload();
      }
    } else if (action === 'toggle') {
      try {
        if (nutritionistData.is_active) {
          await deactivateNutritionist(id);
          toast.success('Nutritionist deactivated successfully');
        } else {
          await activateNutritionist(id);
          toast.success('Nutritionist activated successfully');
        }
        const updatedList = await getNutritionistsList(0, 1000);
        dispatch(setNutritionistsList(updatedList.nutritionists));
      } catch (error: any) {
        console.error('Error toggling nutritionist status:', error);
        if (error?.response?.data?.detail === 'Method Not Allowed') {
          toast.error('Method Not Allowed');
        } else {
          toast.error('Error updating nutritionist status');
        }
      }
    }
  };

  return (
    <div
      className={`table-row ${!nutritionistData.is_active ? 'disabled' : ''}`}
    >
      <div className='avatar'>
        <img src={nutritionistData.photo_url ?? ''} alt='' />
      </div>
      <div className='name'>{`${nutritionistData.last_name} ${nutritionistData.first_name}`}</div>
      <div className='url'>
        {nutritionistData.calendly_url ? (
          <a
            href={nutritionistData.calendly_url}
            target='_blank'
            rel='noreferrer'
          >
            {nutritionistData.calendly_url}
          </a>
        ) : null}
      </div>
      <div className='team'>
        {nutritionistData.team_name || '-'}
      </div>
      <div className='bio'>{nutritionistData.bio}</div>
      <div className='contacts'>
        <span>{nutritionistData.email}</span>{' '}
        <span>{nutritionistData.phone}</span>
      </div>
      <div className='members'>
        <div className='table-count-cell'>{nutritionistData.members_count}</div>
      </div>
      <div className='actions'>
        <TableRowActionMenu
          options={[
            { key: 'edit', value: 'Edit' },
            { key: 'delete', value: 'Delete' },
            {
              key: 'toggle',
              value: nutritionistData.is_active ? 'Deactivate' : 'Activate'
            }
          ]}
          id={nutritionistData.id}
          onActionMenuClick={onOptionClick}
        />
      </div>
    </div>
  );
};

export default NutritionistTableRow;
